import { type VoidFunctionComponent } from 'react';
import FilterCardMultiSelect from '../../../../../../../generic/Filter/FilterCardMultiSelect';
import { userHasPermissionForTeamReleaseGroups } from '../../../../../../../../helpers/permissions';
import { Action } from '../../../../../../../../../typings/permissions';
import styles from '../../../ReleaseGroupsRevamp.module.less';
import type { UseTeamsSelectOptionsReturn } from '../../../../../../../shared/teams/hooks/useTeamsSelectOptions';

const userCanAddReleaseGroupToTeam = (teamId: number): boolean =>
  userHasPermissionForTeamReleaseGroups(Action.Add, teamId);

export type TeamSelectorProps = Pick<UseTeamsSelectOptionsReturn, 'teamOptions' | 'selectedTeamOptions' | 'onTeamsSelected'>;

/**
 * TeamSelector is used on the Policies page to allow the
 * user to assign a release group to one or more teams.
 */
const TeamSelector: VoidFunctionComponent<TeamSelectorProps> = ({
  teamOptions,
  selectedTeamOptions,
  onTeamsSelected,
}) => (
  <div className={`${styles.detailsInputs} ${styles.detailsInputsSolo}`}>
    <FilterCardMultiSelect
      label="Teams"
      requiredText="(optional)"
      placeholder="Select one or more teams to assign this release group to"
      options={teamOptions.filter(team => userCanAddReleaseGroupToTeam(Number(team.value)))}
      values={selectedTeamOptions}
      onChange={onTeamsSelected}
      isSearchable
    />
  </div>
);

export default TeamSelector;
